export { default as Camera } from './Camera';
export {
  Constants,
  getPermissionsAsync,
  requestPermissionsAsync,
  getCameraPermissionsAsync,
  requestCameraPermissionsAsync,
  getMicrophonePermissionsAsync,
  requestMicrophonePermissionsAsync,
} from './Camera';

export {
  BarCodePoint,
  BarCodeScanningResult,
  CameraCapturedPicture,
  CameraMountError,
  CameraNativeProps,
  CameraPictureOptions,
  CameraProps,
  CameraRecordingOptions,
  ConstantsType,
  FaceDetectionResult,
  PermissionResponse,
  PermissionStatus,
  PermissionExpiration,
  Point,
  AutoFocus,
  FlashMode,
  CameraType,
  VideoCodec,
  VideoQuality,
  VideoStabilization,
  WhiteBalance,
} from './Camera.types';
